<div class="container-fluid px-4 mt-4 mb-5" *ngIf="isActive">
    <div class="cp-page-header mb-4">
        <div class="cp-page-title"><i class="fa-solid fa-clipboard-list me-2"></i>Registros</div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a routerLink="/">Inicio</a></li>
                <li class="breadcrumb-item"><a routerLink="/control-ingreso">Control de ingreso</a></li>
                <li class="breadcrumb-item active">Registros</li>
            </ol>
        </nav>
    </div>

    <div class="row g-3">
            <div class="col-xl-3 col-lg-4 col-md-6">
                <div class="card cp-module-card" routerLink="gestion">
                    <div class="cp-module-icon"><i class="fa-solid fa-address-card fa-3x"></i></div>
                    <div class="cp-module-title">Controles de ingreso</div>
                    <div class="cp-module-desc">Filtrar registros</div>
                </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6">
                <div class="card cp-module-card" routerLink="dispositivos">
                    <div class="cp-module-icon"><i class="fa-solid fa-mobile fa-3x"></i></div>
                    <div class="cp-module-title">Dispositivos</div>
                    <div class="cp-module-desc">Registro de dispositivos móviles</div>
                </div>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6">
                <div class="card cp-module-card" routerLink="guardias">
                    <div class="cp-module-icon"><i class="fa-solid fa-person-military-pointing fa-3x"></i></div>
                    <div class="cp-module-title">Guardias</div>
                    <div class="cp-module-desc">Registro de guardias de seguridad</div>
                </div>
            </div>
    </div>
</div>
<router-outlet></router-outlet>
